import DetailsDeal from "@/components/CRM/Deal/DetailsDeal";
import GetAllDeals from "@/components/CRM/Deal/GetAllDeals";
import Loader from "@/components/Loader/Loader";
import PermissionChecker from "@/components/PrivacyComponent/PermissionChecker";
import { Suspense } from "react";
import { Route } from "react-router-dom";

import CommissionBulkUpdate from "@/components/CRM/Deal/CommissionBulkUpdate";

const DealRoutes = [
  <Route
    path="deal"
    element={
      <Suspense fallback={<Loader />}>
        <PermissionChecker permission={["readAll-deal", "readSingle-deal"]}>
          <GetAllDeals />
        </PermissionChecker>
      </Suspense>
    }
    key="deal"
  />,
  <Route
    path="deal/bulk-commission"
    element={
      <Suspense fallback={<Loader />}>
        <PermissionChecker permission={"read-commission"}>
          <CommissionBulkUpdate />
        </PermissionChecker>
      </Suspense>
    }
    key="deal-bulk-commission"
  />,
  <Route
    path="deal/:id"
    element={
      <Suspense fallback={<Loader />}>
        <PermissionChecker permission={"readSingle-deal"}>
          <DetailsDeal />
        </PermissionChecker>
      </Suspense>
    }
    key="deal-single"
  />,
];

export default DealRoutes;

